import { render } from "./dashboardComponent.vue?vue&type=template&id=1b62ad2e&scoped=true"
import script from "./dashboardComponent.vue?vue&type=script&lang=js"
export * from "./dashboardComponent.vue?vue&type=script&lang=js"

import "./dashboardComponent.vue?vue&type=style&index=0&id=1b62ad2e&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src802653185/src/macra-logistics-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b62ad2e"]])

export default __exports__